import { OktaAuth } from '@okta/okta-auth-js';

import oktaConfig from '../config/okta-config';
import { getAccessToken, getIdToken, getUser } from './helper';
import type { ExtendedOktaAuth } from './types';

const oktaAuth = new OktaAuth(oktaConfig as unknown as ConstructorParameters<typeof OktaAuth>[0]);

(oktaAuth as unknown as ExtendedOktaAuth).getAccessToken = () => getAccessToken(oktaAuth);
(oktaAuth as unknown as ExtendedOktaAuth).getIdToken = () => getIdToken(oktaAuth);
(oktaAuth as unknown as ExtendedOktaAuth).getUser = () => getUser(oktaAuth);

export default oktaAuth;
